import { County } from "@/models/county";

export enum INCOME_RANGE {
    FPL_NONE = 0,
    FPL_LVL_1_OR_LESS = 1,
    FPL_LVL_1_TO_LVL_2,
    FPL_LVL_2_TO_LVL_3,
    FPL_LVL_3_PLUS,
    FPL_LVL_1_TO_LVL_3
}

export enum INCOME_RANGE_TEXT_APP{
    FPL_NONE = 0,
    FPL_LVL_1_OR_LESS = 1,
    FPL_LVL_1_TO_LVL_3 = 2,
    FPL_LVL_3_PLUS = 3
}

export enum MARITAL_STATUS{
    NONE = 0,
    SINGLE = 1,
    DIVORCED,
    MARRIED 
}

export interface CareGiver{
    lastName: string;
    firstName: string;
    preferredName: string;
    phoneNumber: string;
    email: string;
    streetAddress: string;
    city: string;
    county: string;
    state: string;
    zipCode: string;
    latitude: number;
    longitude: number;
    currentlyHomeless: boolean;
    searchOtherLocation: boolean;
    otherAddress: string;
    otherCity: string;
    otherCounty: string;
    otherState: string;
    otherLatitude: number;
    otherLongitude: number;
    otherZip: string;
    maritalStatus: MARITAL_STATUS;
    speakEnglish: boolean;
    speakSpanish: boolean;
    speakArabic: boolean;
    speakOther: boolean;
    otherLanguage: string;
}

export interface Child{
    fullName: string;
    birthdate: Date;
    specialNeeds: boolean;
    hasSpecialNeedsPlan: boolean;
}

export interface Household{
  fullTime: boolean;
  partTime: boolean;
  attendingSchool: boolean;
  attendingSchoolFullTime: boolean;
  unemployed: boolean;
  retired: boolean;
  disabilityBenefits: boolean;
  unemploymentBenefits: boolean;
  ssiBenefits: boolean;
  tanfBenefits: boolean;
  mdhhs: boolean;
  noBenefits: boolean;
}

export interface AppData {
    workflowId: string;
    zipCode: string;
    numberInHousehold: number;
    numberChildren: number;
    number4YearOlds: number;
    liveInDetroit: boolean;
    fpl: INCOME_RANGE;
    incomeDisplay: string;
    foster: boolean;
    homeless: boolean;
    benefits: boolean;
    specialNeeds: boolean;
    migrantFarmWork: boolean;
    headStartUnableToFind: boolean | null;
    noHighSchoolGraduation: boolean;
    illiterate: boolean;
    noEnglishHousehold: boolean;
    parentExperiencedAbuse: boolean;
    disability: boolean;
    expelled: boolean;
    englishSecond: boolean;
    noEnglishHome: boolean;
    parentalLoss: boolean;
    toxicExposure: boolean;
    sexualAbuse: boolean;
    neglect: boolean;
    hsQualifierNone: boolean;
    hsQualifierList2None: boolean;
    hsQualifierList3None: boolean;
    hsQualifierUnder4None: boolean;
    hsQualifierUnder4List2None: boolean;
    hsQualifierUnder4List3None: boolean;
    gsrpQualifierNone: boolean;
    gsrpQualifierList2None: boolean;
    protectiveServices: boolean;
    under20Birth: boolean;
    highRiskNeighborhood: boolean;
    siblingIssue: boolean;
    applyHeadStart: boolean;
    applyGreatStart: boolean;
    careGiver: CareGiver;
    children: Array<Child>;
    household: Household;
    eligibleIncome: number;
    howDidYouHear: string;
    howDidYouHearDetails: string;
    howDidYouHearIndex: number;
    howDidYouHearLastIndex: number;
    additionalInfo: string;
    followUp211: boolean;
    signupReady4k: boolean;
    numberOfChildrenApplying: number;
    preferredProgram: string;
    language: string;
    thankYouId: string;
    county: County;
}